document.addEventListener("DOMContentLoaded", () => {
    initializeCalculator();

    document.addEventListener("variant:change", (event) => {
        console.log("variant:change event detected. Reinitializing calculator...");
        initializeCalculator();
    });

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === "childList") {
                const calculatorForm = document.querySelector(".calculator-form");
                if (calculatorForm) {
                    console.log("Calculator block re-rendered. Reinitializing...");
                    initializeCalculator();
                }
            }
        });
    });

    const targetNode = document.querySelector('[data-meta-block]');
    if (targetNode) {
        observer.observe(targetNode, { childList: true, subtree: true });
        console.log("MutationObserver is watching for changes...");
    }
});

function initializeCalculator() {
    console.log("Reinitializing calculator...");

    const calculatorForm = document.querySelector(".calculator-form");
    if (!calculatorForm) {
        console.warn("No calculator form found.");
        return;
    }

    const variantID = document.querySelector('[name="id"]')?.value;
    console.log("Variant ID in initializeCalculator:", variantID);

    const unitSize = parseFloat(calculatorForm.dataset.unitSize) || 1;
    const resultsUnit = calculatorForm.dataset.resultsUnit || '';
    const resultsQtyUnit = calculatorForm.dataset.resultsQtyUnit || '';

    const productDataElement = document.getElementById("main-product-data");
    const productData = productDataElement ? JSON.parse(productDataElement.getAttribute("data-product")) : null;
    const productType = productData ? productData.type : '';

    console.log("Updated Unit Size:", unitSize);
    console.log("Updated Results Unit:", resultsUnit);
    console.log("Updated Results Qty Unit:", resultsQtyUnit);
    console.log("Product Type:", productType);

    const calculateBtn = document.getElementById("calculate-btn");
    const resetBtn = document.getElementById("reset-btn");

    if (calculateBtn) {
        calculateBtn.removeEventListener("click", calculateSoil);
        calculateBtn.addEventListener("click", calculateSoil);
    }

    if (resetBtn) {
        resetBtn.removeEventListener("click", resetFields);
        resetBtn.addEventListener("click", resetFields);
    }
}

function calculateSoil() {
    const calculatorForm = document.querySelector(".calculator-form");
    if (!calculatorForm) return;

    // Get user input values
    const length = parseFloat(document.getElementById("length")?.value);
    const width = parseFloat(document.getElementById("width")?.value);
    const height = parseFloat(document.getElementById("height")?.value);
    const area = parseFloat(document.getElementById("area")?.value);

    // Get dataset attributes
    const unitSize = parseFloat(calculatorForm.dataset.unitSize) || 1;
    const resultsUnit = calculatorForm.dataset.resultsUnit || '';

    // Fetch product type correctly
    const productDataElement = document.getElementById("main-product-data");
    const productData = productDataElement ? JSON.parse(productDataElement.getAttribute("data-product")) : null;
    const productType = productData ? productData.type : '';

    console.log("Inputs - Length:", length, "Width:", width, "Height:", height, "Area:", area);
    console.log("Product Type:", productType, "Results Unit:", resultsUnit, "Unit Size:", unitSize);

    let calculatedArea = 0;
    let value = 0;

    if (resultsUnit === "Lin. Ft." || resultsUnit === "Pi. lin.") {
        calculatedArea = length;
        value = length / unitSize;
    } else if (resultsUnit === "Sq. Ft." || resultsUnit === "Pi. ca.") {
        if (["Border", "Steps", "Wall Caps", "Walls", "Bordure", "Marches", "Couronnements", "Murs"].includes(productType)) {
            calculatedArea = (length * height || area);
            value = calculatedArea / unitSize;
        } else {
            calculatedArea = (length * width || area);
            value = calculatedArea / unitSize;
        }
    }

    if (unitSize <= 0) {
        document.getElementById("result").textContent = "{{ 'calculator.error_invalid_size' | t }}";
        return;
    }

    const roundedValue = Math.ceil(value);
    const resultsQtyUnit = calculatorForm.dataset.resultsQtyUnit || "";
    const productName = productData ? productData.title : "{{ 'calculator.default_product' | t }}";

    let variantText = "";
    const selectedVariantElement = document.querySelector('[name="id"]');
    if (selectedVariantElement) {
        const selectedVariantId = selectedVariantElement.value;
        const selectedVariant = productData?.variants.find(variant => variant.id == selectedVariantId);
        if (selectedVariant && selectedVariant.options) {
            variantText = selectedVariant.options.filter(option => option).join(" ");
        }
    }

    const resultSentenceTemplate = calculatorForm.dataset.resultsLabel;

    const resultText = resultSentenceTemplate
        .replace("{{ calculated_area }}", calculatedArea.toFixed(2))
        .replace("{{ results_unit }}", resultsUnit)
        .replace("{{ rounded_value }}", roundedValue)
        .replace("{{ results_qty_unit }}", resultsQtyUnit)
        .replace("{{ product_name }}", productName)
        .replace("{{ variant_text }}", variantText);

    document.getElementById("result").innerHTML = resultText;
}

function resetFields() {
    const lengthInput = document.getElementById("length");
    if (lengthInput) lengthInput.value = "";
    
    const widthInput = document.getElementById("width");
    if (widthInput) widthInput.value = "";
    
    const heightInput = document.getElementById("height");
    if (heightInput) heightInput.value = "";
    
    const areaInput = document.getElementById("area");
    if (areaInput) areaInput.value = "";
    
    const resultElement = document.getElementById("result");
    if (resultElement) resultElement.textContent = "";
}

function handleVariantChange() {
    const calculatorForm = document.querySelector(".calculator-form");
    if (!calculatorForm) return;

    const variantSelect = document.querySelector('[name="id"]');
    if (variantSelect) {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        const unitSize = parseFloat(selectedOption?.dataset.unitSize) || parseFloat(calculatorForm.dataset.unitSize) || 1;

        calculatorForm.dataset.unitSize = unitSize;
        calculatorForm.dataset.resultsUnit = selectedOption?.dataset.resultsUnit || calculatorForm.dataset.resultsUnit || '';
        calculatorForm.dataset.resultsQtyUnit = selectedOption?.dataset.resultsQtyUnit || calculatorForm.dataset.resultsQtyUnit || '';

        console.log("Updated Unit Size:", unitSize);
        console.log("Updated Results Unit:", calculatorForm.dataset.resultsUnit);
        console.log("Updated Results Qty Unit:", calculatorForm.dataset.resultsQtyUnit);
        console.log("Variant ID in handleVariantChange:", variantSelect.value);
    }
}
